export default __webpack_public_path__ + "static/media/DSC_6235-min.0d69c810.JPG";